import { KeyboardArrowDown } from '@mui/icons-material';
import {
    Autocomplete,
    AutocompleteProps,
    SxProps,
    TextField,
    Theme,
} from '@mui/material';
import React from 'react';

type CAProps<T, M extends boolean, D extends boolean, F extends boolean> = Omit<
    AutocompleteProps<T, M, D, F>,
    'renderInput' | 'size' | 'popupIcon'
> & {
    label?: string;
    placeholder?: string;
    error?: boolean;
    helperText?: React.ReactNode;
    fontSize?: string;
    optionFontSize?: string;
    helperTextFontSize?: string;
    fontWeight?: string | number;
};

const CustomAutocomplete = <
    T,
    M extends boolean = false,
    D extends boolean = false,
    F extends boolean = boolean,
>({
    label,
    placeholder,
    error,
    helperText,
    fontSize,
    optionFontSize,
    helperTextFontSize,
    fontWeight,
    ...rest
}: CAProps<T, M, D, F>) => {
    const fs = fontSize || '12px';
    const optionFs = optionFontSize ?? fs;
    const fw = fontWeight || 500;

    const optionListSx: SxProps<Theme> = {
        '& .MuiAutocomplete-option': { fontSize: optionFs },
    };

    return (
        <Autocomplete<T, M, D, F>
            size='small'
            popupIcon={<KeyboardArrowDown />}
            {...rest}
            ListboxProps={{
                sx: optionListSx,
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder}
                    error={!!error}
                    helperText={helperText}
                    InputLabelProps={{
                        shrink: true,
                        sx: {
                            fontSize: fs,
                            fontWeight: fw,
                            color: 'primary.main',
                            mb: 0.5,
                            display: 'block',
                        },
                    }}
                    sx={{
                        '& .MuiInputBase-input': { fontSize: fs },
                        ...(helperTextFontSize
                            ? {
                                  '& .MuiFormHelperText-root': {
                                      fontSize: `${helperTextFontSize} !important`,
                                  },
                              }
                            : {}),
                    }}
                />
            )}
        />
    );
};

export default CustomAutocomplete;
